import { useRef } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { errText } from "../lib/api";
import { Button } from "./ui/button";
import { FileArrowUp, CircleNotch, ClockCounterClockwise } from "@phosphor-icons/react";

export function PriorYearImport({ clientId }) {
  const qc = useQueryClient();
  const inputRef = useRef();
  const { data } = useQuery({ queryKey: ["py-profile", clientId], queryFn: () => api.get(`/py-profile/${clientId}`).then((r) => r.data) });
  const imp = useMutation({
    mutationFn: (file) => { const fd = new FormData(); fd.append("file", file); return api.post(`/py-import/${clientId}`, fd); },
    onSuccess: ({ data }) => {
      toast.success(`Prior-year profile built — ${data.gaps_detected} gap${data.gaps_detected === 1 ? "" : "s"} detected`);
      qc.invalidateQueries({ queryKey: ["py-profile", clientId] });
      qc.invalidateQueries({ queryKey: ["dossier", clientId] });
    },
    onError: (e) => toast.error(errText(e)),
  });
  const p = data?.profile;
  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-4 mb-4 flex items-center justify-between gap-4" data-testid="py-import-card">
      <div className="min-w-0">
        <p className="text-xs font-medium text-zinc-900 flex items-center gap-1.5"><ClockCounterClockwise size={14} /> Prior-year return profile</p>
        {p ? (
          <p className="text-[10px] text-zinc-500 mt-0.5" data-testid="py-profile-summary">
            Tax year {p.tax_year || "?"} · schedules {(p.active_schedules || []).join(", ") || "—"} · {p.source === "seed_demo" ? "demo seed" : p.source === "client_upload" ? `uploaded by client` : `imported by ${p.imported_by || "firm"}`}{p.source_filename ? ` (${p.source_filename})` : ""}
          </p>
        ) : (
          <p className="text-[10px] text-zinc-500 mt-0.5">No prior-year profile yet — import last year's return PDF to power the cross-year gap engine.</p>
        )}
      </div>
      <Button data-testid="py-import-btn" size="sm" variant="outline" className="h-8 text-xs shrink-0" disabled={imp.isPending} onClick={() => inputRef.current?.click()}>
        {imp.isPending ? <CircleNotch size={13} className="animate-spin mr-1" /> : <FileArrowUp size={13} className="mr-1" />}
        {imp.isPending ? "Reading…" : p ? "Re-import return" : "Import return (PDF)"}
      </Button>
      <input ref={inputRef} type="file" accept=".pdf,image/*" className="hidden" data-testid="py-import-input"
        onChange={(e) => { if (e.target.files[0]) imp.mutate(e.target.files[0]); e.target.value = ""; }} />
    </div>
  );
}
